import { BrowserRouter, Route, Routes } from "react-router-dom";
import Content from "./components/Content/Content";
import AnteHeader from "./components/Header/AnteHeader";
import Header from "./components/Header/Header";
import Layout from "./components/Shared/Layout";
import Tarife from "./pages/Tarife/Tarife";

const App = () => {

  return (
    <BrowserRouter>
      <div>
        <AnteHeader />
        <Header />
        <Layout>
          <Routes>
            <Route path="/" element={<Content />} />
            <Route path="/tarife" element={<Tarife />} />
            <Route path="*" element={<Content />} />
          </Routes>
        </Layout>
      </div>
    </BrowserRouter>
  );
};

export default App;
